import { GetResourceFunction } from "hooks/useResource";
import { camelCase } from "lodash";

export const getFormattedTopics = (
  topics: string,
  getResource: GetResourceFunction,
  isNonCatRec?: boolean,
  isCustomModel?: boolean
) => {
  return topics
    .split(">")
    .map((t) =>
      isNonCatRec
        ? getResource(`recommendationPill.${camelCase(t)}`)
        : isCustomModel
        ? t
        : getResource(`ML.topic.[${t}]`).replaceAll("/", " / ")
    );
};
